module.exports = __webpack_public_path__ + "static/media/bikes.089adfdb.mp4";